module.exports = __webpack_public_path__ + "static/media/YB5F08_1.9163bc7b.jpg";